// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-footer-inner[data-v-6257238c] {\n  padding-bottom: 20px;\n}\n[data-v-6257238c] .el-form-item {\n  margin-right: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
